import styled from 'styled-components';

export const FormGroupBaseStyled = styled.form`
  margin-bottom: 0.75rem;
`;
